<template>
    <div :key="shop.id" class="row user-table-row align-items-center" v-if="shop">
        <div class="col-12 col-md-2 open-td">
<!--            <icon :name="open ? 'icon-cph_iconset_grip' : 'icon-cph_iconset_plus'"
                  fontSize="2em" color="#000"
                  :style="{opacity: showIcon ? '1' : '0'}"
                  v-if="!hideAddition && shop.users && shop.users.length > 0"></icon>-->
            <img class="shop-logo" :src="shop.iconURL" alt="shop logo">
        </div>
        <div class="col-12 col-md-3" v-if="shop.name">
            {{shop.name}}
        </div>
        <div class="col-12 col-md-3" v-if="shop.address">
            {{shop.address.street}} {{shop.address.houseNumber}}
        </div>
        <div class="col-12 col-md-2" v-if="shop.address">
            {{shop.address.postCode}} {{shop.address.city}} / {{shop.address.country}}
        </div>
        <div class="col-12 col-md-2 table-button-container">
            <button class="btn icon-btn pr-0 mx-1"
                    name="add user to shop"
                    data-toggle="tooltip"
                    :disabled="$isNotAllowed($TYPES.ACTIONS.UPDATE)"
                    data-placement="top"
                    :title="$t('UI.assignUser')"
                    @click.stop="$emit('addUserToShop', shop)"
                    v-if="$isAllowed($TYPES.ACTIONS.UPDATE) && !hideAddition">
                <i class="icon icon-cph_iconset_plus"></i>
            </button>
            <button class="btn icon-btn pr-0 mx-1"
                    name="Edit shop"
                    data-toggle="tooltip"
                    :disabled="$isNotAllowed($TYPES.ACTIONS.UPDATE)"
                    data-placement="top"
                    :title="$t('UI.edit')"
                    @click.stop="$emit('editShop')"
                    v-if="$isAllowed($TYPES.ACTIONS.UPDATE) && !hideAddition">
                <i class="icon icon-cph_iconset_edit"></i>
            </button>
            <button class="btn icon-btn pr-0 mx-1"
                    @click.stop="userTableView
                                ? $emit('removeShopFromUser', shop.id)
                                : confirmAction({
                                    question: $t('COMPANYDATA.removeShop'),
                                    data: shop,
                                    callback: deleteShop
                                })"
                    name="delete shop"
                    :disabled="$isNotAllowed($TYPES.ACTIONS.REMOVE)"
                    data-toggle="tooltip"
                    data-placement="top"
                    :title="userTableView
                            ? $t('UI.detatchShop')
                            : $t('COMPANYDATA.removeShop')"
                    v-if="$isAllowed($TYPES.ACTIONS.REMOVE)">
                <i class="icon icon-cph_iconset_trash_can"></i>
            </button>
            <button class="btn icon-btn pr-0 mx-1"
                    @click="$emit('open')"
                    name="show assigned users"
                    :disabled="!hideAddition
                                && !shop.users
                                || shop.users
                                && (shop.users.length === 0)"
                    data-toggle="tooltip" data-placement="top"
                    title="Show assigned users">
                <i class="icon icon-cph_iconset_user"></i>
            </button>

            <button class="btn icon-btn pr-0 mx-1"
                    @click.stop="generateQr"
                    data-toggle="tooltip" data-placement="top" title="Generate qr"
                    name="get qr" v-if="showQrGenerateIconFlag">
                <div class="icon">
                    <img  src="/static/icons/0249-qrcode.svg" alt="qrCode icon">
                </div>
            </button>
        </div>
    </div>
</template>
<script type="text/babel">
import {RegistrationPerimeter} from '../../../../router/perimeters/registrationPerimeter';
import Icon from '../../../Shared/Icons/Icon';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import QRCode from 'qrcode';
export default {
    name: 'shop-table-item',
    data () {
        return {
            showQrGenerateIconFlag: false
        };
    },
    props: {
        currentPage: {},
        shop: {},
        index: '',
        open: {
            type: Boolean
        },
        showIcon: {
            type: Boolean
        },
        hideAddition: {
            type: Boolean
        },
        tableClass: {
            type: String
        },
        userTableView: {
            type: Boolean
        }
    },
    computed: {
        ...mapGetters({user : 'getUser'}),
        setupID(){
          return this.shop.setupID || `${this.shop.id}`;
        }
    },
    components: {Icon},
    perimeters: [RegistrationPerimeter],
    methods: {
        ...mapMutations(['updateUserShopList']),
        ...mapActions([
            'confirmAction',
            'DelShop',
            'DelShopFromUser',
            'GetSetupManagerDataById',
            'GetShopFromUser'
        ]),
        async deleteShop (shop) {
            if(shop.users) {
                await this.$utils.resolvePromises(
                    shop.users.map(({id}) => this.DelShopFromUser({
                        id, shopId: shop.id
                    }))
                );
            }
            await this.DelShop(shop);
            let {data: shops} = await this.GetShopFromUser({id: this.user.id});
            this.updateUserShopList(shops);
        },
        generateQr () {
            const canvas = document.createElement('canvas');
            canvas.width = 1000;
            canvas.height = 1000;

            QRCode.toCanvas(canvas, this.setupID, {
                errorCorrectionLevel: 'H',
                version: 10
            }, (error) => {
                if (error)  {
                    console.error(error);
                } else {
                    let ctx = canvas.getContext('2d');
                    ctx.font = '12px serif';
                    ctx.strokeText('scan this qr code for initial setup', 25, 12);
                    ctx.strokeText(this.shop.name, 25, 255);
                    let url = canvas.toDataURL();
                    let downloadAnchorNode = document.createElement('a');
                    downloadAnchorNode.setAttribute('href', url);
                    downloadAnchorNode.setAttribute('download', `${this.$utils.shortid.generate()}.png`);
                    downloadAnchorNode.click();
                    downloadAnchorNode.remove();
                }
            });
        },
        async showQrGenerateIcon () {
            try {
                //await this.GetSetupManagerDataById(this.setupID);
                this.showQrGenerateIconFlag = true;
            } catch (err) {
                console.error(err);
            }
        }
    },
    created () {
      this.showQrGenerateIcon();
    }

};
</script>

<style lang="scss" scoped>
    .shop-logo{
      width: auto;
      height: 50px;
    }
</style>
